import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Zutrittspunkt } from '../models/zutrittspunkt';
import { BildverifizierungService } from '../services/bildverifizierung.service';
import { Subscription } from 'rxjs';
import { Personal } from '../models/personal';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { LoaderService } from 'src/shared/services/loader.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/shared/shared.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatBadgeModule } from '@angular/material/badge';
import { TableModule } from 'primeng/table';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { MatGridList, MatGridListModule } from '@angular/material/grid-list';

@Component({
    selector: 'app-bildverifizierung',
    standalone: true,
    imports: [
        CommonModule,
        SharedModule,
        MatToolbarModule,
        MatButtonModule,
        MatSelectModule,
        MatFormFieldModule,
        MatCardModule,
        MatBadgeModule,
        TableModule,
        MatTableModule,
        MatGridListModule,
        FormsModule,
    ],
    templateUrl: './bildverifizierung.component.html',
    styleUrl: './bildverifizierung.component.scss',
})
export class BildverifizierungComponent implements OnInit, OnDestroy {
    //#region Variablen
    //#region  protected
    protected istVerbundenZutrittspunkt1: boolean = false;
    protected istVerbundenZutrittspunkt2: boolean = false;
    protected isPhonePortrait: boolean = false;

    protected projektId: string = '';
    protected imgSrc1: string =
        '../../assets/images/placeholder-mitarbeiter-square.png';
    protected imgSrc2: string =
        '../../assets/images/placeholder-mitarbeiter-square.png';
    protected selectedLeseinheitId1!: string;
    protected selectedLeseinheitId2!: string;
    protected selectedClassNameZutrittspunkt1!: string;
    protected selectedClassNameZutrittspunkt2!: string;

    protected personal: Array<Personal> = [
        {
            Firmenname: '',
            Kartennummer: 0,
            Nachname: '',
            PersonalId: '',
            Profilbild: '',
            Richtung: '',
            Success: false,
            Timestamp: '',
            Vorname: '',
        },
        {
            Firmenname: '',
            Kartennummer: 0,
            Nachname: '',
            PersonalId: '',
            Profilbild: '',
            Richtung: '',
            Success: false,
            Timestamp: '',
            Vorname: '',
        },
    ];

    protected personal1!: Personal;
    protected personal2!: Personal;

    protected zutrittspunkte: Array<Zutrittspunkt> = new Array<Zutrittspunkt>();
    //#endregion

    //#region private
    private subscriptions: Array<Subscription> = new Array<Subscription>();
    //#endregion
    //#endregion

    constructor(
        private route: ActivatedRoute,
        private loader: LoaderService,
        private bildverfizierugService: BildverifizierungService,
    ) {}

    public ngOnInit(): void {
        this.projektId = this.route.snapshot.paramMap.get('projektId') || '';

        this.subscriptions.push(
            this.bildverfizierugService
                .getZutrittspunkte(this.projektId)
                .subscribe({
                    next: (data) => {
                        this.zutrittspunkte = data;
                        this.loader.hideLoader();
                    },
                    error: () => {
                        this.loader.hideLoader();
                    },
                }),
        );
    }

    public ngOnDestroy(): void {
        this.bildverfizierugService.closeZutrittspunkt1();
        this.bildverfizierugService.closeZutrittspunkt2();
        this.subscriptions?.forEach((x) => x.unsubscribe());
    }

    public changeSelection2(select: MatSelect): void {
        if (this.selectedLeseinheitId2) {
            this.connectServerSentEventZutrittspunkt2();
        }
    }

    protected connectServerSentEventZutrittspunkt1(): void {
        let projektId = this.projektId;
        if (this.istVerbundenZutrittspunkt1) {
            this.disconnectZutrittspunkt1(this.selectedLeseinheitId1);
        }
        this.subscriptions.push(
            this.bildverfizierugService
                .getServerSentEventZutrittspunkt1(
                    projektId,
                    this.selectedLeseinheitId1,
                )
                .subscribe({
                    next: (event) => {
                        this.istVerbundenZutrittspunkt1 = true;
                        if (JSON.stringify(event).includes('PersonalId')) {
                            this.personal1 = {} as Personal;
                            this.personal1 = JSON.parse(event) as Personal;
                            this.imgSrc1 = this.personal1?.Profilbild
                                ? 'data:image/*;base64,' +
                                  this.personal1?.Profilbild
                                : '../../assets/images/placeholder-mitarbeiter-square.png';
                            this.selectedClassNameZutrittspunkt1 =
                                this.personal1?.Success === false
                                    ? 'background-success'
                                    : 'background-accent';
                        }
                    },
                    error: (error) => {
                        console.log('ERROR', error);
                        this.istVerbundenZutrittspunkt1 = false;
                    },
                }),
        );
    }

    protected disconnectZutrittspunkt1(leseeinheitId?: string): void {
        this.selectedLeseinheitId1 = leseeinheitId ? leseeinheitId : '';
        this.istVerbundenZutrittspunkt1 = false;
        this.selectedClassNameZutrittspunkt1 = '';
        this.personal1 = {} as Personal;
        this.imgSrc1 = '../../assets/images/placeholder-mitarbeiter-square.png';
        this.bildverfizierugService.closeZutrittspunkt1();
    }

    protected connectServerSentEventZutrittspunkt2(): void {
        let projektId = this.projektId;
        if (this.istVerbundenZutrittspunkt2) {
            this.disconnectZutrittspunkt2(this.selectedLeseinheitId2);
        }
        this.subscriptions.push(
            this.bildverfizierugService
                .getServerSentEventZutrittspunkt2(
                    projektId,
                    this.selectedLeseinheitId2,
                )
                .subscribe({
                    next: (event) => {
                        this.istVerbundenZutrittspunkt2 = true;
                        if (JSON.stringify(event).includes('PersonalId')) {
                            this.personal2 = {} as Personal;
                            this.personal2 = JSON.parse(event) as Personal;
                            this.imgSrc2 = this.personal2?.Profilbild
                                ? 'data:image/*;base64,' +
                                  this.personal2?.Profilbild
                                : '../../assets/images/placeholder-mitarbeiter-square.png';
                            this.selectedClassNameZutrittspunkt2 =
                                this.personal1?.Success === true
                                    ? 'background-success'
                                    : 'background-accent';
                        }
                    },
                    error: (error) => {
                        console.log('ERROR', error);
                        this.istVerbundenZutrittspunkt2 = false;
                    },
                }),
        );
    }

    protected disconnectZutrittspunkt2(leseeinheitId?: string): void {
        this.selectedLeseinheitId2 = leseeinheitId ? leseeinheitId : '';
        this.istVerbundenZutrittspunkt2 = false;
        this.selectedClassNameZutrittspunkt2 = '';
        this.personal2 = {} as Personal;
        this.imgSrc2 = '../../assets/images/placeholder-mitarbeiter-square.png';
        this.bildverfizierugService.closeZutrittspunkt2();
    }
}
